import { inject, injectable } from "inversify";
import * as Axios from "axios";

import { IdentityService } from "./identity.service";
import { ConfigurationService } from "./configuration.service";

@injectable()
export class HttpService {
	private http: Axios.AxiosInstance;
	private static timeout: number = 60000;

	@inject(IdentityService)
	private identityService: IdentityService;

	@inject(ConfigurationService)
	private configurationService: ConfigurationService;

	public online = (): Promise<Axios.AxiosResponse> => {
		return this.get("/api/v1/online");
	}

	public get = async (url: string, config?: {}): Promise<Axios.AxiosResponse> => {
		const http = await this.setup();
		try {
			const response = await http.get(url, this.getConfig(config));
			return response;
		} catch (reason) {
			if (Axios.default.isCancel(reason)) {
				throw new Error(reason.message);
			}
			this.handleError(reason);
		}
	}

	public post = async (url: string, data: any, config?: {}): Promise<Axios.AxiosResponse> => {
		const http = await this.setup();
		try {
			const response = await http.post(url, data, this.getConfig(config));
			return response;
		} catch (reason) {
			if (Axios.default.isCancel(reason)) {
				throw new Error(reason.message);
			}
			this.handleError(reason);
		}
	}

	private async setup(): Promise<Axios.AxiosInstance> {
		if (this.http) {
			Promise.resolve(this.http);
		}

		const config = await this.configurationService.current();
		this.http = Axios.default.create({
			timeout: HttpService.timeout,
			baseURL: config.serviceUrl,
		});
		return this.http;
	}

	private getConfig(data?: {}): Axios.AxiosRequestConfig {
		const config = {
			headers: {
				'Authorization': `Bearer ${this.identityService.accessToken}`,
				'Cache-Control': 'no-cache',
			},
		};
		return data
			? {
				...config,
				...data,
			}
			: config;
	}

	private handleError(error: Axios.AxiosError) {
		if (error.response && error.response.status) {
			switch (error.response.status) {
				case 401:
					this.identityService.logOff();
					throw new Error("Access is denied. You could try to log in again, if the problem persist, contact your administrator.");
				case 400:
					if (error.response.data.error && error.response.data.error == "invalid_grant") {
						throw new Error("Access is denied. You could try to log in again, if the problem persist, contact your administrator.");
					} else {
						return error;
					}
				default:
					return error;
			}
		} else {
			return error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/core/services/http.service.ts